import React from "react";
import classNames from "classnames";
import ProductsResults from "../ProductsResults";
import Stack from "theme/components/atoms/Layout/Stack";
import Link from "theme/components/atoms/Typography/Link";
import SearchBarResultsEmpty from "./SearchBarResultsEmpty";
import { FormattedMessage } from "react-intl";
import SearchBarResultsLoading from "./SearchBarResultsEmptyLoading";
import SearchBarResultsError from "./SearchBarResultsEmptyError";
import { useAutocompleteOption } from "theme/components/organisms/Autocomplete/useAutocomplete";

const hasResults = ({ products, categories }) =>
  products.length > 0 || categories.length > 0;

const SearchBarResults = (props) => {
  const isEmpty = !props.results || !hasResults(props.results);

  const [isAllSelected, allAutocompleteProps] = useAutocompleteOption(
    "all",
    props.searchUrl,
    props.selected,
    props.onSelect
  );

  if (props.loading && isEmpty) {
    return <SearchBarResultsLoading />;
  }
  if (props.error) {
    return <SearchBarResultsError />;
  }
  if (isEmpty) {
    return <SearchBarResultsEmpty />;
  }

  const hasProducts = props.results.products.length > 0;

  return (
    <div className={classNames("searchbar-results")}>
      <Stack size="2">
        <div className="searchbar-results__results">
          {hasProducts && (
            <div key="products" className="searchbar-results__element">
              <ProductsResults
                results={props.results.products}
                selected={props.selected}
                onSelect={props.onSelect}
              />
            </div>
          )}
        </div>
        <div className="center">
          <span {...allAutocompleteProps}>
            <Link
              buttonAppearance={isAllSelected ? "primary" : "default"}
              to={props.searchUrl}
            >
              <FormattedMessage
                id="modules.Search.SearchBar.SearchBarResults.viewAll"
                defaultMessage="See all results"
              />
            </Link>
          </span>
        </div>
      </Stack>
    </div>
  );
};

export default SearchBarResults;
